import axios from 'axios';

export default {
  getVersions({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/versions/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertVersions', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
